<template>
 <div style="background-color: #ffffff">
  <Row>
   <div
    style="display: inline-block;margin-right: 5px;">
    <Button size="small" type="dashed" @click="onallCount">全部:{{allCount}}</Button>
   </div>
   <div
    style="display: inline-block;margin-right: 5px">
    <!--    运行:{{runCount}}-->
    <Button size="small" type="success" @click="onrunCount">运行:{{runCount}}</Button>
   </div>
   <div
    style="display: inline-block;margin-right: 5px">
    <!--    停车:{{stopCount}}-->
    <Button size="small" type="info" @click="onstopCount">停车:{{stopCount}}</Button>
   </div>
   <div
    style="display: inline-block;margin-right: 5px">
    <!--    报警:{{alarmCount}}-->
    <Button size="small" type="error" @click="onalarmCount">报警:{{alarmCount}}</Button>
   </div>
   <!--   <div-->
   <!--    style="display: inline-block;margin-right: 5px">-->
   <!--    &lt;!&ndash;    报警:{{alarmCount}}&ndash;&gt;-->
   <!--    <Button size="small" type="warning">异常:{{alarmCount}}</Button>-->
   <!--   </div>-->
   <Button size="small" style="margin-left: 5px;" @click="onUnsubscribeAllClick">取消全部监控</Button>
   <Button size="small" style="margin-left: 5px;" @click="onSwitchingPath">清除轨迹</Button>
   <Input size="small" v-model="searchRealtimeVehicleRegistrationNoKeyword" placeholder="车牌号码..."
          style="width: 200px; margin-left: 15px;"
          :search="true" @on-search="onRealtimeVehicleSearch"/>

   <div style="float: right;margin-right: 20px">
    <Poptip trigger="hover" content="导出表格" placement="bottom-end">
     <Button size="small" type="text" icon="ios-cloud-download" @click="onDownloadTable"></Button>
     <!--     <Button v-if="!showMinimum" size="small" type="text" icon="ios-photos-outline" @click="onOriginalState"></Button>-->
    </Poptip>
    <Poptip trigger="hover" content="最小化" placement="bottom-end">
     <Button size="small" type="text" icon="md-remove" @click="onMinimum"></Button>
     <!--     <Button v-if="!showMinimum" size="small" type="text" icon="ios-photos-outline" @click="onOriginalState"></Button>-->
    </Poptip>
    <Poptip trigger="hover" content="最大化" placement="bottom-end">
     <Button size="small" type="text" icon="md-square-outline" @click="onMaximize"></Button>
     <!--    <Button size="small" type="text" icon="ios-photos-outline" @click="onOriginalState"></Button>-->
    </Poptip>
    <Poptip trigger="hover" content="窗口化" placement="bottom-end">
     <Button size="small" type="text" icon="ios-photos-outline" @click="onOriginalState"></Button>
    </Poptip>
   </div>
   <div style="float: right;margin-right: 120px">
    <Poptip trigger="hover" content="报警取消" placement="bottom-end">
     <Button size="small" type="text" icon="md-warning" @click="showwarn"></Button>
     <!--     <Button v-if="!showMinimum" size="small" type="text" icon="ios-photos-outline" @click="onOriginalState"></Button>-->
    </Poptip>
   </div>
  </Row>
  <Row>
   <context-menu ref="bigDataTableContextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
    <div style="width: 100%;">
    <bigdata-table
    @contextmenu.prevent.native="onBigDataTableRightClick($event)"
    style="height: 500px;"
    ref="bigDataTableRef"
    v-model="bigDataTableDataHandled"
    :row-num="20"
    :col-num="bigDataColumnsCount"
    fixed
    stripe
    :index-width="80"
    :col-width="100"
    :header-height="20"
    :row-height="30"
    :can-edit="bigDataCanEdit"
    :at-right-cell-posi="20"
    :at-left-cell-posi="40"
    :columns="bigDataColumns"
    :fixed-col="0"
    :sort-index="bigDataSortIndex"
    :default-sort="bigDataDefaultSort"
    selectable
    paste
    :beforeSave="bigDataBeforeSave"
    :disabled-hover="false"
    :highlightRow="true"
    @on-success-save="bigDataHandleSuccessEdit"
    @on-fail-save="bigDataHandleFailEdit"
    @on-moving-on-header="bigDataHandleMoving"
    @on-click-tr="bigDataHandleClickTr"
    @on-click-td="bigDataHandleClickTd"
    @on-index-change="bigDataHandleClickIndex"
   ></bigdata-table>
    </div>
  </Row>
  <web-table-columns-modal @columnListChange="onColumnListChange" :columnList.sync="bigDataColumns"
                           :tableName="$options.name"
                           v-model="bigDataTableWebTableColumnsModal"></web-table-columns-modal>
 </div>
</template>
<script>
import bigdataTable from '_c/vue-bigdata-table'
import indexRender from '_c/vue-bigdata-table/index-render.js'

import { registrationTextColor, registrationColor } from '@/libs/registrationutil'
import { isAccOn, explainDirection, explainState, explainAlarmSign } from '@/libs/jt808util'

export default {
  name: 'vehicledymaicinfotable',
  components: {
    bigdataTable
  },
  props: {
    tableHeight: {
      require: true
    },
    onOriginalState: {
      require: true
    },
    onDownloadTable: {
      require: true
    },
    onMinimum: {
      require: true
    },
    onMaximize: {
      require: true
    },
    allCount: {
      require: true
    },
    alarmCount: {
      require: true
    },
    runCount: {
      require: true
    },
    stopCount: {
      require: true
    }
  },
  data () {
    return {
      showMinimum: true,

      allresult: null,

      bigDataTableWebTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],
      // 统计数据 ----------------------------------
      // 大数据列表 ---------------------------------
      searchRealtimeVehicleRegistrationNoKeyword: null,
      bigDataTableData: [],

      realtimeVehicleInfoData: [], // 实时数据表
      realtimeVehicleInfoDataBackup: {}, // 实时数据表备份
      // bigDataColumns: [],
      bigDataTableDataHandled: [], // 带有数据的表格数据
      bigDataEmptyData: [], // 空的表格数据
      bigDataScrollIndex: 1,
      bigDataCanEdit: false,
      bigDataEditRow: 1,
      bigDataEditCol: 1,
      bigDataSortIndex: [2, 3, 4, 5],
      bigDataDefaultSort: { 0: 'up' },
      bigDataColumnsCount: 10,
      indexRender,
      bigDataIndexRenderParams: {
        index: -1
      },
      bigDataColumns: [
        {
          title: '序号',
          align: 'center',
          width: 40,
          cellRender: (h, params) => {
            return h('span', {
              style: {
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }
            }, params.row + 1)
          }
        },
        {
          title: '名称',
          width: 110,
          sortable: 'custom',
          cellRender: (h, params) => {
            return h('Button', {
              props: {
                disabled: false,
                size: 'small'
              },
              style: {
                backgroundColor: this.bigDataTableDataHandled[params.row] ? registrationColor(this.bigDataTableDataHandled[params.row].registrationColor) : '#FFFFFF',
                color: this.bigDataTableDataHandled[params.row] ? registrationTextColor(this.bigDataTableDataHandled[params.row].registrationColor) : '#FFFFFF'
              },
              on: {
                click: () => {
                  this.$emit('onVehicleNameClick', params)
                  // let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(params.mainKey)
                  // if (vehicleInfo) {
                  //   this.$refs.arcgisMonitorMapRef.onCloseVehicleInfoWindow()
                  //   this.$refs.arcgisMonitorMapRef.onRealtimeMarkerClick(vehicleInfo, false)
                  //   this.$refs.arcgisMonitorMapRef.mapCenterAt(vehicleInfo.gis.realtimeMarker.geometry)
                  // }
                }
              }
            }, params.value)
          }
        },
        {
          title: '行驶速度',
          align: 'center',
          width: 80,
          cellRender: (h, params) => {
            let speed = (params.value / 10) + 'km/h'
            return h('label', speed)
          }
        },
        {
          title: '方向',
          align: 'center',
          width: 80,
          cellRender: (h, params) => {
            return h('label', explainDirection(params.value))
          }
        },
        {
          title: '定位时间',
          align: 'center',
          width: 180,
          cellRender: (h, params) => {
            if (params.value) {
              return h('span', {
                style: {
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }
              }, new Date(params.value).Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '运行状态',
          align: 'center',
          width: 100
        },
        {
          title: '持续时长',
          align: 'center',
          width: 110
        },
        {
          title: '状态',
          align: 'center',
          width: 600,
          cellRender: (h, params) => {
            let s = ''
            let sl = explainState(params.value)
            sl.forEach(item => {
              s += item + '|'
            })
            return h('span', {
              style: {
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }
            }, s)
          }
        },
        {
          title: '报警',
          align: 'center',
          width: 300,
          cellRender: (h, params) => {
            return h('span', {
              style: {
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }
            }, explainAlarmSign(params.value))
          }
        },
        {
          title: '位置',
          align: 'center',
          width: 300
        }
      ]
    }
  },
  watch: {
    tableHeight (newV, oldV) {
    // do something
    // console.log(newV, oldV)
      this.$refs.bigDataTableRef.$el.style.height = newV + 'px'
    }
  },
  methods: {
    showwarn () {
      this.$emit('showwarn')
    },
    // onMinimum(){
    //  if (this.showMinimum){
    //   this.showMinimum=false
    //  } else {
    //   this.showMinimum=true
    //  }
    // },
    onallCount () {
      this.$refs.bigDataTableRef.cancelFilter()
    },
    onrunCount () {
      this.$refs.bigDataTableRef.filter(5, ['行驶', '停车未熄火'])
    },
    onstopCount () {
      this.$refs.bigDataTableRef.filter(5, ['停止'])
    },
    onalarmCount () {
      this.$refs.bigDataTableRef.filterZero(8)
    },
    makeSortIndex (result) {
      this.bigDataDefaultSort = []
      this.bigDataSortIndex = []
      result.forEach(item => {
        if (item.title === '序号') {
        } else if (item.title === '名称') {
          this.bigDataSortIndex.push(item.sortIndex, 'down')
          this.bigDataDefaultSort.push(item.sortIndex, 'up')
        } else if (item.title === '行驶速度') {
          this.bigDataSortIndex.push(item.sortIndex)
        } else if (item.title === '方向') {
          this.bigDataSortIndex.push(item.sortIndex)
        } else if (item.title === '定位时间') {
          this.bigDataSortIndex.push(item.sortIndex)
        } else if (item.title === '运行状态') {
        } else if (item.title === '持续时长') {
        } else if (item.title === '状态') {
        } else if (item.title === '报警') {
        } else if (item.title === '位置') {
        }
      })
    },

    /**
    * 表格列变化回调
    */
    onColumnListChange (result) {
      this.allresult = result
      this.bigDataColumnsCount = this.bigDataColumns.length
      this.makeSortIndex(result)
      let tempArray = []
      console.log(this.realtimeVehicleInfoDataBackup)
      if (this.realtimeVehicleInfoDataBackup) {
        let hashMap = this.realtimeVehicleInfoDataBackup
        for (let prop in hashMap) {
          let dataItem = hashMap[prop]
          let tempData = new Array(result.length)
          result.forEach(item => {
            tempData.mainKey = prop
            tempData.registrationColor = dataItem.registrationColor
            if (item.title === '序号') {
              tempData[item.sortIndex] = dataItem.id
            } else if (item.title === '名称') {
              tempData[item.sortIndex] = dataItem.displayName
            } else if (item.title === '行驶速度') {
              tempData[item.sortIndex] = dataItem.speed
            } else if (item.title === '方向') {
              tempData[item.sortIndex] = dataItem.direction
            } else if (item.title === '定位时间') {
              tempData[item.sortIndex] = dataItem.gpsDatetime
            } else if (item.title === '运行状态') {
              tempData[item.sortIndex] = dataItem.terminalState
            } else if (item.title === '持续时长') {
              tempData[item.sortIndex] = dataItem.terminalStateSpan
            } else if (item.title === '状态') {
              tempData[item.sortIndex] = dataItem.state
            } else if (item.title === '报警') {
              tempData[item.sortIndex] = dataItem.alarm
            } else if (item.title === '位置') {
              tempData[item.sortIndex] = dataItem.address
            }
          })
          tempArray.push(tempData)
        }
      }
      console.log(tempArray)
      this.realtimeVehicleInfoData = tempArray
      this.bigDataTableDataHandled = tempArray
      console.log(this.bigDataTableDataHandled)
      this.updateRealtimeVehicleInfoTable()
    },

    /**
    * 大数据表格右键回调
    */
    onBigDataTableRightClick (e) {
      this.$refs.bigDataTableContextMenuRef.showMenu(e, this.$el)
    },

    /**
    * 右键菜单点击回调
    */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.bigDataTableWebTableColumnsModal = true
      }
    },
    /**
    * 清除轨迹线
    */
    onSwitchingPath () {
      this.$emit('onSwitchingPath')
    },

    /**
    * 清除表格
    */
    clearBigData () {
      this.realtimeVehicleInfoData = []
      this.realtimeVehicleInfoDataBackup = {}
      this.bigDataTableDataHandled = this.realtimeVehicleInfoData
      this.updateRealtimeVehicleInfoTable()
    },

    /**
    * 取消监控所有车辆
    */
    onUnsubscribeAllClick () {
      this.$emit('onUnsubscribeAllClick')
      this.realtimeVehicleInfoData = []
      // this.bigDataTableData = this.realtimeVehicleInfoData
      this.realtimeVehicleInfoDataBackup = {}
      this.bigDataTableDataHandled = this.realtimeVehicleInfoData
      // this.bigDataEmptyData = []

      this.updateRealtimeVehicleInfoTable()
    },

    /**
    * 移除实时车辆缓存数据
    */
    removeRealtimeVehicleInfoCache (vehicleInfo) {
      let removeIndex = -1
      let realtimeLocationFrame = vehicleInfo.dymaic.realtimeLocationFrame
      if (!realtimeLocationFrame) {
        return
      }
      let terminalNum = realtimeLocationFrame.terminalNum
      let length = this.realtimeVehicleInfoData.length
      for (var i = 0; i < length; i++) {
        let v = this.realtimeVehicleInfoData[i]
        if (v.mainKey == terminalNum) {
          removeIndex = i
          break
        }
      }
      if (removeIndex != -1) {
        this.realtimeVehicleInfoData.splice(removeIndex, 1)
      }
    },

    /**
    * 更新实时车辆数据Table
    */
    updateRealtimeVehicleInfoTable () {
      this.$refs.bigDataTableRef.updateTable()
    },

    /**
    * 更新实时车辆缓存数据
    */
    updateRealtimeVehicleInfoCache (vehicleInfo) {
      let existData = null
      let realtimeLocationFrame = vehicleInfo.dymaic.realtimeLocationFrame
      let terminalNum = realtimeLocationFrame.terminalNum
      let length = this.realtimeVehicleInfoData.length
      for (let i = 0; i < length; i++) {
        let v = this.realtimeVehicleInfoData[i]
        if (v.mainKey == terminalNum) {
          existData = v
          break
        }
      }
      if (!existData) {
        // 新增缓存数据
        let displayName = vehicleInfo.registrationNum === null ? vehicleInfo.vin : vehicleInfo.registrationNum
        if (vehicleInfo.customName) {
          // displayName = '(' + vehicleInfo.customName + ')' + displayName
          displayName = vehicleInfo.customName
        }
        let index = -1
        let pushData = new Array(this.bigDataColumns.length)
        index = this.findColumnIndex('序号')
        if (index) {
          pushData[index] = vehicleInfo.id
        }
        index = this.findColumnIndex('名称')
        if (index) {
          pushData[index] = displayName
        }
        index = this.findColumnIndex('行驶速度')
        if (index) {
          pushData[index] = realtimeLocationFrame.speed
        }
        index = this.findColumnIndex('方向')
        if (index) {
          pushData[index] = realtimeLocationFrame.direction
        }
        index = this.findColumnIndex('定位时间')
        if (index) {
          pushData[index] = realtimeLocationFrame.gpsDatetime.seconds * 1000
        }
        index = this.findColumnIndex('运行状态')
        if (index) {
          pushData[index] = vehicleInfo.info.terminalState
        }
        index = this.findColumnIndex('持续时长')
        if (index) {
          pushData[index] = vehicleInfo.info.terminalStateSpan
        }
        index = this.findColumnIndex('状态')
        if (index) {
          pushData[index] = realtimeLocationFrame.state
        }
        index = this.findColumnIndex('报警')
        if (index) {
          pushData[index] = realtimeLocationFrame.alarm
        }
        index = this.findColumnIndex('位置')
        if (index) {
          pushData[index] = vehicleInfo.info.address
        }
        this.realtimeVehicleInfoDataBackup[terminalNum] = {
          id: vehicleInfo.id,
          displayName: displayName,
          speed: realtimeLocationFrame.speed,
          direction: realtimeLocationFrame.direction,
          gpsDatetime: realtimeLocationFrame.gpsDatetime.seconds * 1000,
          terminalState: vehicleInfo.info.terminalState,
          terminalStateSpan: vehicleInfo.info.terminalStateSpan,
          state: realtimeLocationFrame.state,
          alarm: realtimeLocationFrame.alarm,
          address: vehicleInfo.info.address,

          registrationColor: vehicleInfo.registrationColor
        }
        // let pushData = [
        //   vehicleInfo.id,
        //   displayName,
        //   realtimeLocationFrame.speed,
        //   realtimeLocationFrame.direction,
        //   realtimeLocationFrame.gpsDatetime.seconds * 1000,
        //   vehicleInfo.info.terminalState,
        //   vehicleInfo.info.terminalStateSpan,
        //   // realtimeLocationFrame.recvDatetime.seconds * 1000,
        //   realtimeLocationFrame.state,
        //   realtimeLocationFrame.alarm,
        //   vehicleInfo.info.address
        // ]
        pushData.mainKey = terminalNum
        pushData.terminalState = vehicleInfo.info.terminalState
        pushData.alarm = realtimeLocationFrame.alarm
        pushData.registrationColor = vehicleInfo.registrationColor
       if (!vehicleInfo.registrationNum && !vehicleInfo.customName) {
        pushData.registrationNum = vehicleInfo.vin
       }else {
        pushData.registrationNum = vehicleInfo.registrationNum + vehicleInfo.customName
       }
        // pushData.customName = vehicleInfo.customName
        this.realtimeVehicleInfoData.push(pushData)
      } else {
        // console.log('更新缓存')
        let index = -1
        // index = this.findColumnIndex('序号')
        // if(index){
        //   existData[index] = vehicleInfo.id
        // }
        // index = this.findColumnIndex('名称')
        // if(index){
        //   existData[index] = displayName
        // }
        index = this.findColumnIndex('行驶速度')
        if (index) {
          existData[index] = realtimeLocationFrame.speed
        }
        index = this.findColumnIndex('方向')
        if (index) {
          existData[index] = realtimeLocationFrame.direction
        }
        index = this.findColumnIndex('定位时间')
        if (index) {
          existData[index] = realtimeLocationFrame.gpsDatetime.seconds * 1000
        }
        index = this.findColumnIndex('运行状态')
        if (index) {
          existData[index] = vehicleInfo.info.terminalState
        }
        index = this.findColumnIndex('持续时长')
        if (index) {
          existData[index] = vehicleInfo.info.terminalStateSpan
        }
        index = this.findColumnIndex('状态')
        if (index) {
          existData[index] = realtimeLocationFrame.state
        }
        index = this.findColumnIndex('报警')
        if (index) {
          existData[index] = realtimeLocationFrame.alarm
        }
        index = this.findColumnIndex('位置')
        if (index) {
          existData[index] = vehicleInfo.info.address
        }
        let backup = this.realtimeVehicleInfoDataBackup[terminalNum]
        if (backup) {
          backup.speed = realtimeLocationFrame.speed
          backup.direction = realtimeLocationFrame.direction
          backup.gpsDatetime = realtimeLocationFrame.gpsDatetime.seconds * 1000
          backup.terminalState = vehicleInfo.info.terminalState
          backup.terminalStateSpan = vehicleInfo.info.terminalStateSpan
          backup.state = realtimeLocationFrame.state
          backup.alarm = realtimeLocationFrame.alarm
          backup.address = vehicleInfo.info.address
        }
        // existData[2] = realtimeLocationFrame.speed
        // existData[3] = realtimeLocationFrame.direction
        // existData[4] = realtimeLocationFrame.gpsDatetime.seconds * 1000
        // existData[5] = vehicleInfo.info.terminalState
        // existData[6] = vehicleInfo.info.terminalStateSpan
        // existData[7] = realtimeLocationFrame.state
        // existData[8] = realtimeLocationFrame.alarm
        // existData[9] = vehicleInfo.info.address
      }
    },

    findColumnIndex (name) {
      for (let i = 0; i < this.bigDataColumns.length; i++) {
        if (name === this.bigDataColumns[i].title) {
          return this.bigDataColumns[i].sortIndex
        }
      }
      return null
    },

    initBigDataTable () {
      this.bigDataTableDataHandled = this.realtimeVehicleInfoData
      console.log(this.bigDataTableDataHandled)
    },
    bigDataHandleMoving (e) {

    },
    bigDataScrollToVehicle (id) {
      let length = this.realtimeVehicleInfoData.length
      let index = -1
      for (var i = 0; i < length; i++) {
        if (this.realtimeVehicleInfoData[i][0] == id) {
          console.log('匹配车辆')
          console.log(id)
          console.log(this.realtimeVehicleInfoData[i])
          index = i
          break
        }
      }
      if (index != -1) {
        // this.bigDataScrollRowTo(index)
      }
    },
    bigDataScrollRowTo (index) {
      this.$refs.bigDataTableRef.scrollToRow(index)
    },
    bigDataHandleClickTr (index) {
    // console.log(index)
    },
    bigDataHandleClickTd (params) {
    // console.log(params)
    },
    bigDataClickEditBtn () {
      this.canEdit = !this.canEdit
    },
    bigDataBeforeSave ({ row, col, value }) {
      return (row + 1) % 2
    },
    bigDataHandleSuccessEdit ({ row, col, value, initRowIndex }) {
      console.log(`第${row + 1}行第${col + 1}列改为${value}`)
    },
    bigDataHandleFailEdit (res) {
      console.log('偶数行不能编辑')
    },
    bigDataEditCell () {
      this.$refs.bigDataTableRef.editCell(this.editRow - 1, this.editCol - 1)
    },
    bigDataChangeData (rowLen) {
      let dataArr = []
      for (let i = 0; i < rowLen; i++) {
        let arr = [
          i + '00',
          'count' + i,
          '23.4534534345',
          '0023' + i,
          '123.234534534534',
          'namenasdfsdfsdfsdfssdfsdfsdsdfsdfsf' + i,
          '2014年1月1日'
        ]
        dataArr.push(arr)
      }
      this.bigDataTableDataHandled = dataArr
      console.log(this.bigDataTableDataHandled)
    },
    bigDataChangeDefaultSort () {
      this.defaultSort = { 1: 'up' }
    },
    bigDataHandleClickIndex (index) {
      this.indexRenderParams.index = index
    },

    /**
    * 车辆名称搜索
    * @param input
    */
    onRealtimeVehicleSearch (input) {
      console.log(input)
      this.$refs.bigDataTableRef.vehiclefilter(1, [input.toLocaleUpperCase()])
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.bigDataTableRef.$el.style.height = this.tableHeight + 'px'
      console.log(this.tableHeight)
      this.initBigDataTable()
    })
  }
}
</script>
<style lang="less">

 .header-title-wraper {
  height: 100%;
  width: 100%;

  .mark-con {
   height: ~"calc(40% - 1px)";
   width: 100%;
   border-bottom: 1px solid #e9eaec;;
   text-align: center;
   line-height: 27px;
  }

  .title-con {
   height: 60%;
   width: 100%;
   text-align: center;
   line-height: 41px;
  }
 }

 .unormal-value {
  background: #FFA3A1 !important;
 }

 .unormal-row {
  background: #FFD8D3 !important;
 }

 .unormal-index {
  background: #FF4C5E !important;
  color: white;
  font-size: 14px;
  font-weight: 700;
  height: 100%;
  line-height: 48px;
 }

 .index-render-item-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;

  .index-slide-wrapper {
   width: 200%;
   height: 100%;
   position: absolute;
   top: 0px;
   left: 0px;
   transform: translateX(0);
   transition: all .2s ease;

   &.slide-to-left {
    transform: translateX(-50%);
    transition: all .2s ease;
   }

   div {
    float: left;
    width: 50%;
    height: 100%;
   }

   .index-render-tip-con {
    background: #FFD0D0;
    line-height: 46px;

    .is-paintting-tip {
     padding: 4px 10px;
    }
   }

   .index-render-num-con {
    & > span {
     display: inline-block;
     height: 100%;
     line-height: 46px;
    }
   }
  }
 }
</style>
